(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScriptsReleasesDetailController', ScriptsReleasesDetailController);

    ScriptsReleasesDetailController.$inject = ['$scope', '$rootScope', 'entity'];

    function ScriptsReleasesDetailController($scope, $rootScope, entity) {
        var vm = this;
        vm.scriptsReleases = entity;

        var unsubscribe = $rootScope.$on('jotApp:scriptsReleasesUpdate', function(event, result) {
            vm.scriptsReleases = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
